import useFormOperations from "@Totum/QuestionnaireBuilder/Application/hooks/useFormOperations";
import { isPresent } from "@Totum/Main/Utils";

/**
 * Presents the `QuestionsForm` component with the UI model and handlers.
 */
const useQuestionsFormPresenter = () => {
    // ** Hooks ** //
    const { questionnaire, addQuestion } = useFormOperations();

    // ** Handlers ** //

    /**
     * Handles the addition of a new row to the questionnaire
     */
    const handleAddRow = (): void => {
        addQuestion();
    };

    /**
     * Changes the order of the rows in the questionnaire
     */
    const handleRearrangeRows = (): void => {};

    // ** Exports ** //

    return {
        handlers: {
            handleAddRow,
            handleRearrangeRows,
        },

        uiModel: {
            questionnaireId: questionnaire.questionnaireId,

            items: questionnaire.questions.map((question) => ({
                ...question,
                id: question.questionId,
            })),

            findQuestion: (id: string) => questionnaire.questions.find((q) => q.questionId === id),

            // flags
            canAddRow: questionnaire.questions.every((question) => isPresent(question.questionId)),
        },
    };
};

export default useQuestionsFormPresenter;
